import { render } from "./AllTours.vue?vue&type=template&id=17904078"
import script from "./AllTours.vue?vue&type=script&lang=js"
export * from "./AllTours.vue?vue&type=script&lang=js"

import "./AllTours.vue?vue&type=style&index=0&id=17904078&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__